import { useState, useEffect } from "react";
import { LOGO_URL } from "@/data/content";

const Logo = ({ className = "h-8 sm:h-9 md:h-10 lg:h-11 w-auto", dark = false }) => {
  const [error, setError] = useState(false);
  const [fallbackTried, setFallbackTried] = useState(false);
  const [imgSrc, setImgSrc] = useState(LOGO_URL);

  useEffect(() => {
    setImgSrc(LOGO_URL);
    setError(false);
    setFallbackTried(false);
  }, []);

  const handleError = () => {
    if (!fallbackTried) {
      setFallbackTried(true);
      setImgSrc("/place8_logo.png");
    } else {
      setError(true);
    }
  };

  if (error) {
    return (
      <div className={`inline-flex items-center gap-2 font-display text-2xl font-bold tracking-tight ${dark ? "text-white" : "text-green-primary"}`}>
        <span className="grid h-8 w-8 place-items-center rounded-lg bg-gold-primary text-white text-xs font-black tracking-widest shadow-sm">
          P8
        </span>
        <span className="tracking-tight">
          PLACE<span className="text-gold-primary">8</span>
        </span>
      </div>
    );
  }

  return (
    <img
      src={imgSrc}
      alt="PLACE8 Talent Recruitment Consultancy Logo"
      onError={handleError}
      className={`object-contain object-left bg-transparent border-0 shadow-none transition-transform duration-300 hover:scale-[1.02] ${className}`}
    />
  );
};

export default Logo;
